// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbedComments_wrapper__3n84l","content":"EmbedComments_content__13fu9"};